import classNames from "classnames";
import styles from "./ScrollableArea.module.scss";
import Scrollbars from "react-custom-scrollbars-2";

type ScrollableAreaProps = {
  children?: React.ReactNode;
  className?: string;
  disableHorizontal?: boolean;
  disableVertical?: boolean;
  horizontalTrackStyle?: React.CSSProperties;
  showTrack?: boolean;
  style?: React.CSSProperties;
  verticalTrackStyle?: React.CSSProperties;
};

function ScrollableArea(props: ScrollableAreaProps) {
  return (
    <Scrollbars
      className={classNames(styles.scroll, props.className, {
        [styles.disableHorizontal]: props.disableHorizontal,
        [styles.disableVertical]: props.disableVertical,
      })}
      style={props.style}
      hideTracksWhenNotNeeded={true}
      renderTrackHorizontal={({ style, ...renderProps }) => (
        <div
          {...renderProps}
          className={classNames(styles.trackHorizontal, {
            [styles.hidden]: props.disableHorizontal,
            [styles.track]: props.showTrack,
          })}
          style={{
            ...style,
            ...props.horizontalTrackStyle,
          }}
        ></div>
      )}
      renderThumbHorizontal={(renderProps) => (
        <div {...renderProps} className={styles.thumbHorizontal}></div>
      )}
      renderTrackVertical={({ style, ...renderProps }) => (
        <div
          {...renderProps}
          className={classNames(styles.trackVertical, {
            [styles.hidden]: props.disableVertical,
            [styles.track]: props.showTrack,
          })}
          style={{
            ...style,
            ...props.verticalTrackStyle,
          }}
        ></div>
      )}
      renderThumbVertical={(renderProps) => (
        <div {...renderProps} className={styles.thumbVertical}></div>
      )}
    >
      {props.children}
    </Scrollbars>
  );
}

export { ScrollableArea };
